import { useQuery } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

type Params = {
  fromCurrency: string;
  toCurrency: string;
  mediaItemId: string;
};

export const useCurrencyRateApi = ({
  fromCurrency,
  toCurrency,
  mediaItemId,
}: Params) => {
  return useQuery({
    ...MediaPlan.getMediaItemCurrencyRateQueryOptions({
      params: {
        fromCurrency,
        toCurrency,
      },
      urlParams: {
        mediaItemId,
      },
    }),
    enabled: !!fromCurrency && !!toCurrency && !!mediaItemId,
  });
};
